import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Partnership from './components/Partnership';
import Stats from './components/Stats';
import HowItWorks from './components/HowItWorks';
import TryVoxie from './components/TryVoxie';
import Monetization from './components/Monetization';
import UseCases from './components/UseCases';
import Telecoms from './pages/Telecoms';
import Footer from './components/Footer';
import SEO from './components/SEO';
// Main content component to avoid duplication
const MainContent = () => <main data-id="element-0">
    <Hero data-id="element-1" />
    <HowItWorks data-id="element-2" />
    <TryVoxie data-id="element-3" />
    <UseCases data-id="element-4" />
    <Features data-id="element-5" />
    <Partnership data-id="element-6" />
    <Stats data-id="element-7" />
    <Monetization data-id="element-8" />
  </main>;
export function App() {
  return <BrowserRouter data-id="element-9">
      <div className="w-full min-h-screen bg-white" data-id="element-10">
        <SEO data-id="element-11" />
        <Header data-id="element-12" />
        <Routes data-id="element-13">
          {/* Default route */}
          <Route path="/" element={<MainContent data-id="element-15" />} data-id="element-14" />
          {/* Language-specific routes for main page */}
          <Route path="/es" element={<MainContent data-id="element-17" />} data-id="element-16" />
          <Route path="/fr" element={<MainContent data-id="element-19" />} data-id="element-18" />
          <Route path="/pt" element={<MainContent data-id="element-21" />} data-id="element-20" />
          {/* Telecoms routes */}
          <Route path="/telecoms" element={<Telecoms data-id="element-23" />} data-id="element-22" />
          <Route path="/es/telecoms" element={<Telecoms data-id="element-25" />} data-id="element-24" />
          <Route path="/fr/telecoms" element={<Telecoms data-id="element-27" />} data-id="element-26" />
          <Route path="/pt/telecoms" element={<Telecoms data-id="element-29" />} data-id="element-28" />
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-31" />} data-id="element-30" />
        </Routes>
        <Footer data-id="element-32" />
      </div>
    </BrowserRouter>;
}